export const socials: { name: string; imageSource: string; link: string }[] = [
  {
    name: 'LinkedIn',
    imageSource: '/assets/images/linkedin-profile.png',
    link: 'https://www.linkedin.com/in/joseph-w-valdez/',
  },
  {
    name: 'Portfolio',
    imageSource: '/assets/images/portfolio.png',
    link: 'https://josephvaldez.vercel.app/',
  },
  {
    name: 'GitHub',
    imageSource: '/assets/images/github-profile.png',
    link: 'https://github.com/joseph-w-valdez',
  },
  {
    name: 'Repository',
    imageSource: '/assets/images/repository.png',
    link: 'https://github.com/joseph-w-valdez/Valorant-Checker',
  },
];
